"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _SidePaneDetailsComponent = _interopRequireDefault(require("../../common/SidePaneDetailsComponent/SidePaneDetailsComponent"));
var _numberFormatter = require("../../../helpers/numberFormatter");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var SendReceiveDetailsComponent = /*#__PURE__*/function (_React$Component) {
  function SendReceiveDetailsComponent() {
    _classCallCheck(this, SendReceiveDetailsComponent);
    return _callSuper(this, SendReceiveDetailsComponent, arguments);
  }
  _inherits(SendReceiveDetailsComponent, _React$Component);
  return _createClass(SendReceiveDetailsComponent, [{
    key: "render",
    value: function render() {
      var t = this.props.t;
      var _this$props = this.props,
        isSend = _this$props.isSend,
        useExternalAddress = _this$props.useExternalAddress,
        balance = _this$props.balance,
        Amount = _this$props.details.Amount,
        ProductSymbol = _this$props.product.ProductSymbol,
        TicketAmount = _this$props.TicketAmount,
        fee = _this$props.fee;
      var getItem = _SidePaneDetailsComponent["default"].getItem;
      var title = isSend ? t("Send Details") : t("Instructions");
      var amountText = t("Amount to Send");
      var remainingBalance = (0, _numberFormatter.formatNumberToLocale)(balance - (useExternalAddress ? TicketAmount + fee : Amount), ProductSymbol);
      var classModifiers = isSend ? 'top' : '';
      var items = [];
      var info = [];
      var infoHeader = '';
      if (isSend) {
        items.push(getItem(t("Your current {{ProductSymbol}} Balance", {
          ProductSymbol: ProductSymbol
        }), balance ? "".concat((0, _numberFormatter.formatNumberToLocale)(balance, ProductSymbol), " ").concat(ProductSymbol) : '-'));
        items.push(getItem(amountText, Amount ? "".concat((0, _numberFormatter.formatNumberToLocale)(useExternalAddress ? TicketAmount : Amount, ProductSymbol), " ").concat(ProductSymbol) : '-'));
        items.push(getItem(t("Fee"), useExternalAddress ? "".concat((0, _numberFormatter.formatNumberToLocale)(fee, ProductSymbol), " ").concat(ProductSymbol) : '-'));
        items.push(getItem(t("Remaining Balance"), Amount && balance ? "".concat(remainingBalance, " ").concat(ProductSymbol) : '-'));
      }
      if (isSend && !useExternalAddress) {
        infoHeader = t("Note");
        info.push(t("If the sender is not a registered user of Retail, they will receive an email invitation to create an account and claim their funds."));
      }
      if (!isSend && !useExternalAddress) {
        info.push(t("Use this form to request funds via email."));
        info.push(t("Note - if the requestee is not a registered user of Retail, they will receive an email invitation to create an account."));
      }
      if (!isSend && useExternalAddress) {
        info.push(t("Depositing cryptocurrency into your wallet is safe and easy. The address below can always be used to deposit cryptocurrency into your account."));
        info.push(t("Your account will automatically update after the cryptocurrency network confirms your transaction. The confirmation may take up to 1 hour"));
      }
      return /*#__PURE__*/_react["default"].createElement(_SidePaneDetailsComponent["default"], {
        title: title,
        items: items,
        info: info,
        infoHeader: infoHeader,
        classModifiers: classModifiers
      });
    }
  }]);
}(_react["default"].Component);
SendReceiveDetailsComponent.propTypes = {
  isSend: _propTypes["default"].bool,
  useExternalAddress: _propTypes["default"].bool,
  details: _propTypes["default"].object,
  fee: _propTypes["default"].number,
  TicketAmount: _propTypes["default"].number
};
var _default = exports["default"] = (0, _reactI18next.withTranslation)("send")(SendReceiveDetailsComponent);